import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";
import BlogCard from "../main-blog/blog-card";

export default function Article({ id, trackHeight, minHeight }) {
  const [article, setArticle] = useState(null);

  useEffect(() => {
    storefront
      .request({
        query: queries.getArticle,
        variables: {
          id,
        },
      })
      .then(({ data }) => {
        setArticle(data.article);
      });
  }, [id]);

  return (
    article && (
      <BlogCard
        article={article}
        trackHeight={trackHeight}
        minHeight={minHeight}
      />
    )
  );
}
